import React from "react";
import { useParams } from "react-router-dom";
import { ContainerInfo } from "../components/Container/ContainerInfo";
import { IframeModelViewer } from "../components/modelviewer/IframeModelViewer";
import { models } from "../types/modelsDatabase";

export const PageProductById = () => {
	const { id } = useParams();
	const product = models.find((model) => model.id === parseInt(id));
	if (product) {
		return (
			<div className="relative">
				<div className="overflow-y-auto relative h-full">
					<IframeModelViewer selectModel={product.model} />
					<div className="bg-primary rounded-t-3xl">
						<ContainerInfo />
					</div>
				</div>
			</div>
		);
	} else {
		return <></>;
	}
};
